var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "classnames", "prop-types", "react", "../../UI/Interchange/Interchange"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("classnames"), require("prop-types"), require("react"), require("../../UI/Interchange/Interchange"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames, global.propTypes, global.react, global.Interchange);
    global.TeaserVOD = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classnames, _propTypes, _react, _Interchange) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _classnames = _interopRequireDefault(_classnames);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _Interchange = _interopRequireDefault(_Interchange);

  var TeaserVOD = function TeaserVOD(_ref) {
    var images = _ref.images,
        placeholder = _ref.placeholder,
        title = _ref.title,
        titlesElement = _ref.titlesElement,
        tracking = _ref.tracking,
        url = _ref.url,
        urlRel = _ref.urlRel,
        urlTarget = _ref.urlTarget,
        visible = _ref.visible;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('teaser-vod', {
        'is-placeholder': placeholder
      })
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "teaser-vod__link",
      href: url,
      target: urlTarget,
      rel: urlRel,
      onClick: tracking
    }, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
      breakpointFormat: {
        xsmall: 'portrait',
        small: 'portrait',
        medium: 'portrait',
        large: 'portrait',
        xlarge: 'portrait',
        xxlarge: 'portrait'
      },
      images: images,
      placeholder: false,
      title: title,
      visible: visible
    }), titlesElement));
  };

  TeaserVOD.propTypes = {
    images: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    placeholder: _propTypes.default.bool,
    title: _propTypes.default.string.isRequired,
    titlesElement: _propTypes.default.node,
    tracking: _propTypes.default.func,
    url: _propTypes.default.string.isRequired,
    urlRel: _propTypes.default.string,
    urlTarget: _propTypes.default.string,
    visible: _propTypes.default.bool
  };
  TeaserVOD.defaultProps = {
    placeholder: false,
    tracking: function tracking() {},
    visible: true
  };
  var _default = TeaserVOD;
  _exports.default = _default;
});